module.exports = __webpack_public_path__ + "static/pro-42164017d79e058fb63dc2778b96ea5c.png";